import { SVGProps } from 'react';

export const Home = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.7365 8.81389L9.63649 0.713877C9.28459 0.361976 8.71579 0.361976 8.36389 0.713877L0.263871 8.81389C0.00647033 9.07129 -0.0709298 9.45829 0.0685705 9.7949C0.208071 10.1315 0.536572 10.3502 0.900172 10.3502H2.70018V17.5502H7.20018V13.0502H10.8002V17.5502H15.3002V10.3502H17.1002C17.4638 10.3502 17.7923 10.1315 17.9318 9.7949C18.0713 9.45829 17.9939 9.07129 17.7365 8.81389Z"
      fill="currentColor"
    />
  </svg>
);
